import { AppContext } from '@/store';
import { addHrefLang } from '@/store/hrefLang/actions';
import { readCsvLine } from '@/utils/helpers';
import React, { useContext } from 'react';
import { format, getExclusionPaths, isPathExcluded } from './SEOHrefLang.facade';

interface SEOHrefLangProps {
  hrefLangsRaw?: string;
  countryCodesWhitelist?: string;
  exclusionPaths?: string;
}
const SEOHrefLang = ({
  hrefLangsRaw = '',
  countryCodesWhitelist = '',
  exclusionPaths = '',
}: SEOHrefLangProps) => {
  const { dispatch } = useContext(AppContext);

  const pathsToExclude = React.useMemo<string[]>(
    () => getExclusionPaths(exclusionPaths),
    [exclusionPaths],
  );
  const hrefLangs = React.useMemo(() => {
    try {
      return JSON.parse(hrefLangsRaw);
    } catch (_error) {
      return '';
    }
  }, [hrefLangsRaw]);

  const whitelist = React.useMemo<string[]>(() => {
    try {
      return readCsvLine({ data: countryCodesWhitelist }) || [];
    } catch (e) {
      return [];
    }
  }, [countryCodesWhitelist]);

  React.useEffect(() => {
    if (!(!!hrefLangs && Object.keys(hrefLangs).length)) {
      dispatch(addHrefLang([]));
      return;
    }
    if (isPathExcluded({ path: window.location.href, pathsToExclude }) || !whitelist.length) {
      dispatch(addHrefLang([]));
      return;
    }

    const hrefLangsFormatted = format({ hrefLangs, whitelist });
    dispatch(addHrefLang(hrefLangsFormatted));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hrefLangsRaw, countryCodesWhitelist, exclusionPaths]);

  return null;
};

export default React.memo(SEOHrefLang);
